import { b2bLanguageCodes, languageCodes } from '../i18n.js';
export function detectOKLanguage(appOK, navigator) {
    const languages = navigator.languages || [navigator.language];
    const userOK = languages.map((item) => item.substring(0, 2));
    const ok = userOK.filter((item) => appOK.includes(item));
    return ok[0];
}
export const defaultLanguage = (detectOKLanguage(languageCodes, window.navigator) || 'en');
export const defaultB2bLanguage = (detectOKLanguage(b2bLanguageCodes, window.navigator) || 'de');
//# sourceMappingURL=languageUtils.js.map